import React, { useState } from "react"; 
import "./Gallery.css";
import GalleryHero from "../components/GalleryHero.jsx";
import GalleryCategories from "../components/GalleryCategories.jsx";
import GalleryGrid from "../components/GalleryGrid.jsx";
import CTA from "../components/CTA.jsx";
import FAQ from "../components/FAQ.jsx";
import ContactUs from "../components/ContsctUs.jsx";
import Footer from "../components/Footer";
import "./Gallery.css";

const Gallery = () => {

  const [selectedCategory, setSelectedCategory] = useState("All");

  return (
    <div className="gallery-page">
      {/* Hero */}
      <GalleryHero />
      <GalleryCategories onCategoryChange={setSelectedCategory} />
      <GalleryGrid category={selectedCategory} />
        <CTA />
        <FAQ />
        <ContactUs />
      <Footer />
    </div>
  );
};

export default Gallery;
